import { Redirect } from 'react-router-dom';
import GuestGuard from '../guards/GuestGuard';
import AuthLayout from '../layouts/auth';
import { PATH_AUTH } from './paths';
import lazy from './lazy';

const AuthRoutes = {
  path: PATH_AUTH.root,
  layout: AuthLayout,
  routes: [
    {
      exact: true,
      path: PATH_AUTH.login,
      component: lazy(() => import('../views/authentication/Login')),
      guard: GuestGuard,
    },
    {
      exact: true,
      path: PATH_AUTH.kbHandoff,
      component: lazy(() => import('../views/authentication/KbAuthHandoff')),
    },
    {
      exact: true,
      path: PATH_AUTH.mobileHandoff,
      component: lazy(
        () => import('../views/authentication/MobileAuthHandoff')
      ),
      // Exchange the handoff even when the browser already has a dashboard
      // session so it can switch to the organization selected in the mobile app.
    },
    {
      exact: true,
      path: PATH_AUTH.impersonationHandoff,
      component: lazy(
        () => import('../views/authentication/ImpersonationHandoff')
      ),
      // No guard: a super admin's link replaces whatever session this
      // white-label dashboard already had.
    },
    {
      exact: true,
      path: PATH_AUTH.resetPassword,
      component: lazy(() => import('../views/authentication/ResetPassword')),
      guard: GuestGuard,
    },
    {
      exact: true,
      path: PATH_AUTH.verifyEmail,
      component: lazy(() => import('../views/authentication/VerifyEmail')),
    },
    {
      component: () => <Redirect to="/404" />,
    },
  ],
};

export default AuthRoutes;
